import knowledgeBase from "../zhCn/knowledgeBase";

export default {
  FileUploadSizeLimit: 'File size must be less than 10MB!',
  
  FileEncoding: 'File encoding error, please save as UTF-8 format and upload again, or contact customer service',
  TokenLimit: 'Size limit exceeded, single application token count cannot exceed 1 million, please contact customer service for additional requirements',
  KnowledgeBaseUpdating: 'Knowledge base updating, please wait~',
  FileTypeError: 'Please upload txt, pdf, md, docx format files',
  CSVFormatError: 'Please upload csv format file',
  FileName: 'Name',
  FileType: 'Type',
  FileSize: 'Size (KB)',
  KnowledgeBaseCount: 'Chunks',
  UpdateTime: 'Update Time',
  Operation: 'Operation',
  View: 'View',
  Create: 'Create',
  Edit: 'Edit',
  Export: 'Export',
  Preview: 'Preview',
  Delete: 'Delete',
  Rename: 'Rename',
  CreateFile: 'Create File',
  ImportFile: 'Import Files',
  ImportType: 'Import Type',
  ImportTypeTooltip: 'Import Type ',
  Import: 'Import',
  ManualCreate: 'Manual Create',
  Document: 'Document',
  QA: 'Q&A',
  Table: 'Table',
  Website: 'Website',
  SearchPlaceholder: 'Search files',
  SearchKnowledgeContent: 'Search file content',
  Refresh: 'Refresh',
  DeleteConfirm: 'This will delete the file data from the knowledge base',
  DeleteFile: 'Delete File',
  ConfirmDelete: 'Confirm Delete',
  DeleteSuccess: 'Delete successful',
  CancelDelete: 'Cancel Delete',
  PleaseEnterFileName: 'Please enter file name',
  CreateSuccess: 'Create successfully',
  ModifyName: 'Modify Name',
  Cancel: 'Cancel',
  Confirm: 'Confirm',
  All: 'All',
  Status: 'Status',
  Effective: 'Effective',
  Failed: 'Failed',
  Processing: 'Processing',
  FileExporting: 'File exporting, data processing takes time, please wait patiently~',
  CreateNewFile: 'New File',
  SerialNumber: 'ID',
  Tokens: 'Tokens',
  ManualCreation: 'Manual Creation',
  SelectFileType: 'Select File Type',
  CreateTable: 'Create Table',
  ExcelIcon: 'Excel Icon',
  UploadFile: 'Upload file',
  FileNameRequired: 'File name is required',
  FileNameTooLong: 'File name cannot exceed 50 characters',
  FileNameInvalid: 'File name can only contain letters, numbers, underscores and hyphens',
  Type: 'Type',
  Add: 'Add',
  Back: 'Back',
  Content: 'Content',
  Question: 'Question',
  Answer: 'Answer',
  dragAndDropFile: 'Drag and drop a file or ',
  clickToUpload: 'Click to upload',
  UploadTip: 'Supports images, videos and files, up to 15MB per file',
  SearchMethod: 'Search Method',
  SearchMethodTooltip: 'In semantic search, only search question semantic similarity, or search both question and answer semantic similarity',
  QuestionOnly: 'Question Only',
  QuestionAndAnswer: 'Question and Answer',
  PreviewFile: 'Preview File',
  AddMaterial: 'Add Material',
  AddMaterialTip: 'After uploading, the material will be automatically added to the answer content as a link',
  DeleteData: 'Delete Data',
  DeleteDataConfirm: 'Delete this data from the file',
  ConfirmDeleteBtn: 'Confirm Delete',
  CancelDeleteBtn: 'Cancel',
  DeleteSuccessMsg: 'Delete successful',
  CancelDeleteMsg: 'Delete cancelled',
  EnterContent: 'Please enter content',
  EnterQuestion: 'Please enter question',
  EnterAnswer: 'Please enter answer',
  FileUploadSuccess: 'File {filename} uploaded successfully',
  Total: 'Total {count} items',
  PleaseWait: 'Please wait',
  KnowledgeBaseName: 'Knowledge name',
  KnowledgeBaseCode: 'Knowledge Code',
  knowledgeBaseNameTitle: 'Name',
  knowledgeBaseDescriptionTitle: 'Description',
  KnowledgeBaseDescription: 'Description',
  PleaseEnterKnowledgeBaseName: 'Enter knowledge name',
  PleaseEnterKnowledgeBaseDescription: 'Enter knowledge description',
  KnowledgeBaseSaveSuccess: 'Knowledge base saved successfully',
  DeleteKnowledgeBase: 'Delete Knowledge Base',
  DeleteKnowledgeBaseConfirm: 'This will delete all files in this knowledge base and its bindings with applications, are you sure?',
  AutoParseDocuments: 'Auto Parse Documents, Easy to Use',
  qaImport: 'Q&A Import, Enhanced Accuracy',
  StructuredTableImport: 'Structured Table Import, Supports Multi-Column Retrieval',
  WebImport: 'Web Import, Automatically Retrieve Content',
  ImportIndependentWebsite: 'Import Independent Website',
  ImportBasedOnWebsiteMap: 'Import Based on Website Map',
  ImportBasedOnWebsiteMapTooltip: 'Automatically retrieve content from the website root address or website map',
  WebsiteAddress: 'Website Address',
  WebsiteAddressTooltip: 'Website Address ',
  CurrentVersionLimit: 'Current version can add {count} websites (including sub-pages with deep parsing)',
  CurrentVersionLimitTooltip: 'Current version can retrieve {count} pages from the website map',
  InputWebsiteAddress: 'Enter the root address of the website or the URL of the website map (sitemap.xml)',
  BatchInputWebsiteAddress: 'Batch input website addresses (starting with http or https), separated by line breaks',
  DeepParsing: 'Deep Parsing',
  DeepParsingTooltip: 'Automatically parse sub-links in the page and retrieve content, import the webpage and its sub-pages with one click',
  ImportFeishu: 'Import Feishu',
  ImportFeishuTooltip: 'Not supported for Feishu multi-dimensional tables',
  FeishuAuthorization: 'Feishu Authorization',
  ViewAuthorization: 'View Authorization',
  GoAuthorization: 'Go Authorization',
  UploadFileTooltip: 'Upload file ',
  SupportFileFormat: 'Supports txt, pdf, md, and docx file formats. You can upload a maximum of {count} files at a time, with a single file size not exceeding {size}MB.',
  SupportCsvFileFormat: 'Supports CSV (two-column) format files. You can upload up to {count} files at a time, with each file not exceeding {size} MB.',
  UploadFileFormat: 'Upload file must match the template file format (CSV UTF-8 format)',
  DownloadCsvTemplate: 'Download CSV Template',
  supportCsvXlsxFormat: 'Supports CSV (UTF-8) format and XLSX format files. Please upload one file, with a size not exceeding {count} MB, and the number of rows in a single import should not exceed {size} rows.',
  CloudDocumentAddress: 'Cloud Document Address',
  OnlineTableAddress: 'Online Table Address',
  CloudDocumentAddressTooltip: 'Cloud Document Address ',
  OnlineTableAddressTooltip: 'Online Table Address ',
  CurrentVersionLimitCloudDocument: 'Current version can add {count} cloud documents',
  CurrentVersionLimitOnlineTable: 'Single table data row does not exceed {size} rows',
  InputSingleFeishuWordAddress: 'Input single Feishu table address (starting with https)',
  BatchInputDocumentAddress: 'Batch input document addresses (starting with https), separated by line breaks',
  EnhancedParsing: 'Enhanced Parsing',
  EnhancedParsingTooltip: 'Parse images and tables in pdf and docx documents and import them into the knowledge base',
  Parsing: 'Parsing',
  ParsingFailed: 'This website does not support import',
  ParseLength: 'Segment Length',
  CurrentSegment: 'Current Segment ',
  SearchStrategy: 'Search Strategy ',
  SearchStrategyTooltip: 'Only search questions: Only search for this material based on the relevant text in the question, but the similarity search is higher',
  SearchStrategyTooltip2: 'Search both questions and answers: Search for this material based on the relevant text in the question or answer, but the similarity search will decrease',
  PreviewAfterImportDocuments: 'Preview after importing files',
  PreviewAfterImportQuestionsAndAnswers: 'Preview after importing questions and answers',
  PreviewAfterImportTables: 'Preview after importing tables',
  PreviewAfterImportWebsites: 'Preview after importing websites',
  SegmentPreview: 'Segment Preview',
  SegmentPreviewTooltip: 'Currently previewing only the first 50 paragraphs',
  Segment: 'Segment',
  QuestionTooltip: 'Question ',
  AnswerTooltip: 'Answer ',
  Index: 'Index',
  IndexColumn: 'Index Column',
  IndexColumnTooltip: 'Whether to participate in indexing: After selection, user questions will be matched with the content in this column for semantic similarity/keyword retrieval',
  IndexColumnTooltipTips: 'Tips:',
  IndexColumnTooltipTips1: '1、Once the index column is determined, it cannot be modified',
  IndexColumnTooltipTips2: '2、The model inference will refer to the column name, you can modify the column name, the column name cannot be repeated',
  IndexColumnTooltipTips3: '3、When a user question matches a value in the index column, the entire row of data in which the value is located will be used as the hit content of the knowledge base',
  TotalRecords: 'Total {count} records, currently previewing only the first 50 rows',
  SingleFileParagraphs: 'Single File Paragraphs ',
  SingleFileTokens: 'Single File Tokens ',
  SingleFilePrice: 'Single File Price ',
  EstimatedTotalPrice: 'Estimated Total Price ',
  Points: 'Points',
  CancelImport: 'Cancel Import',
  RePreview: 'Re Preview',
  ConfirmImport: 'Confirm Import',
  UseTips: 'Use Tips',
  UseTipsContent: 'When using the "Website Import" feature, the website address you submit should be a website you have the right to use or use, and you are responsible for the legality of the submitted website content. The platform only provides website parsing import services and does not assume any responsibility for your use of website data. It is recommended to import static websites such as blogs, public account articles, official website text information pages, and usage instructions pages, and temporarily does not support some domestic media websites.',
  UseTipsContent2: 'It is recommended to import static websites such as blogs, public account articles, official website text information pages, and usage instructions pages, and temporarily does not support some domestic media websites.',
  IAgree: 'I Agree',
  SelfBuiltApplicationAuthorization: 'Self-Built Application Authorization',
  PleaseUploadCsvTxtPdfMdDocxFormatFile: 'Please upload csv, txt, pdf, md, docx format files',
  PleaseUploadCsvFormatFile: 'Please upload csv format file',
  PleaseUploadCsvOrXlsxFormatFile: 'Please upload csv or xlsx format file',
  FileSizeMustBeLessThan: 'File size must be less than',
  PleaseReLogin: 'Please re-login',
  PointsNotEnough: 'Points not enough',
  CurrentFileNotParsed: 'Current file not parsed, continue import?',
  CancelImportFile: 'Cancel Import',
  ConfirmImportFile: 'Confirm Import',
  KnowledgeBaseFileImporting: 'Knowledge base file importing, data processing takes time, please wait patiently~',
  ImportFileSuccess: 'File submitted successfully, data is being processed at high speed, you can click the refresh button to view the latest status',
  FileUploading: 'File uploading, please wait!',
  FileParsing: 'File parsing, please wait!',
  BindSuccess: 'Bind successful',
  PleaseInputSingleFeishuTableAddress: 'Please input single Feishu table address',
  PleaseInputDocumentAddress: 'Please input document address',
  PleaseSelectImportMethod: 'Please select import method',
  PleaseEnterTheXMLAddress: 'Please enter the XML address',
  PleaseEnterTheWebsiteDomainName: 'Please enter the website domain name',
  Image: 'Image',
  Video: 'Video',
  File: 'File',
  Miniprogram: 'Miniprogram',
  Card: 'Card',
  Upload: 'Upload',
  MediaResource: {
    Name: 'Name',
    Type: 'Type',
    Size: 'Size (KB)',
  },
  UploadMaterial: 'Upload Media',
  FileRenameSuccess: 'File name modified successfully',
  DeleteFileConfirm: 'Are you sure you want to delete this file?',
  CopySuccess: 'Copy successful',
  CopySuccessMsg: 'Copy successful, effective after being added to the knowledge base',
  TestText: 'Test Text',
  PleaseEnterTheQuestionToBeSearched: 'Please enter the text to be tested',
  Retrieval: 'Retrieval',
  RetrievalResult: 'Retrieval Result',
  RetrievalResultTips: '1. The results of semantic retrieval and full-text retrieval are displayed here, each with 10 rows. In actual use, the results will be combined (duplicates removed) according to the strategy configuration for enhanced retrieval in the knowledge base',
  RetrievalResultTips2: '2. If there is no matching keyword in the content, the full-text retrieval result may not exist; if the content is limited, it may be less than 10 rows',
  SemanticRetrievalResult: 'Semantic Retrieval Result',
  NoResult: 'No Result',
  Similarity: 'Similarity ',
  WebsiteImport: 'Website Import',
  FullTextRetrievalResult: 'Full-Text Retrieval Result',
  Sort: 'Sort:',
  Retrieving: 'Retrieving, please wait patiently~',
  CreateKnowledgeBase: 'Create knowledge',
  PleaseGiveEnterKnowledgeBaseName: 'Enter knowledge name',
  KnowledgeBaseNeedToBeBoundToKnowledgeApplication: 'Knowledge needs to be bound to the agent to take effect',
  PleaseFillInTheContent: 'Please fill in the content',
  AddSuccess: 'Add Success',
  AddFailed: 'Add Failed',
  removeDataFromFile: 'Remove this data from the file.',
  modificationSuccess: 'Modification successful.',
  modificationFailed: 'Modification failed.',
  FileManagement: 'Files',
  RetrievalMode: "Retrieval Mode",
  FileImport: 'Import',
  MediaManagement: 'Media',
  RetrievalTest: 'Retrieval Test',
  Configuration: 'Settings',
  HowToChoose: 'How to choose ',
  ImportMethod: 'import method',
  HowToChooseImportMethod: 'How to choose ',
  maxUploadFilesPerSession: 'You can upload a maximum of {count} files at a time.',
  maxImportCount: 'You can add up to {count} Feishu cloud documents in a single import.',
  maxImportUrls: 'You can add up to {count} URLs in a single import.',
}
